import * as React from "react";
import { createRoot } from 'react-dom/client';
import './../public/assets/css/ontario-design-system/styles/ds-theme.min.css';

import App from "./App";

console.warn = () => { };
const container = document.getElementById('root');
const root = createRoot(container);
root.render( <App  />);
